/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProcurementType {
    PURCHASE = 'purchase',
    LEASING = 'leasing',
    RENTAL = 'rental'
}


export function instanceOfProcurementType(value: any): boolean {
    for (const key in ProcurementType) {
        if (Object.prototype.hasOwnProperty.call(ProcurementType, key)) {
            if (ProcurementType[key as keyof typeof ProcurementType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProcurementTypeFromJSON(json: any): ProcurementType {
    return ProcurementTypeFromJSONTyped(json, false);
}

export function ProcurementTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcurementType {
    return json as ProcurementType;
}

export function ProcurementTypeToJSON(value?: ProcurementType | null): any {
    return value as any;
}

export function ProcurementTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ProcurementType {
    return value as ProcurementType;
}

